(function () {
  function formatMoney(cents) {
    var fm = window.FoxTheme && window.FoxTheme.Currency && window.FoxTheme.Currency.formatMoney;
    var format = window.FoxTheme && window.FoxTheme.settings ? window.FoxTheme.settings.moneyFormat : null;
    if (fm && format) return fm(cents, format);
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function init() {
    var bar = document.querySelector('[data-ma-gift-bar]');
    if (!bar) return;

    var tiers;
    try {
      tiers = JSON.parse(bar.dataset.tiers || '[]');
    } catch (e) {
      tiers = [];
    }
    if (!tiers.length) return;

    var baseCartCents = parseInt(bar.dataset.cartTotalCents, 10) || 0;

    var priceBlock = document.querySelector('.product__block--price');
    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    var baseCents = priceBlock ? (parseInt(priceBlock.dataset.priceCents, 10) || null) : null;
    var qtyInput = form ? form.querySelector('input[name="quantity"]') : null;
    var checkboxes = Array.from(document.querySelectorAll('.ma-addons-box__checkbox'));
    var bundlePicker = document.querySelector('.ma-bundle-picker');

    var fillEl = bar.querySelector('[data-ma-gift-bar-fill]');
    var countEl = bar.querySelector('[data-ma-gift-bar-count]');
    var remainingEl = bar.querySelector('[data-ma-gift-bar-remaining]');
    var tierEls = Array.from(bar.querySelectorAll('[data-ma-gift-bar-tier]'));

    function addonsTotal() {
      return checkboxes.reduce(function (sum, cb) {
        return sum + (cb.checked ? (parseInt(cb.dataset.price, 10) || 0) : 0);
      }, 0);
    }

    function pendingCents() {
      if (baseCents == null) return 0;
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      if (bundlePicker) {
        if (qty === 2) {
          var discountPct = parseFloat(bundlePicker.dataset.discountPct) || 0;
          return Math.round((baseCents * 2 * (100 - discountPct)) / 100);
        }
        if (qty === 3) {
          var tier3Pct = parseFloat(bundlePicker.dataset.tier3DiscountPct) || 0;
          return Math.round((baseCents * 3 * (100 - tier3Pct)) / 100);
        }
        return baseCents;
      }
      return baseCents * qty + addonsTotal();
    }

    function render() {
      var totalCents = baseCartCents + pendingCents();
      var lastTier = tiers[tiers.length - 1];
      var fillPct = lastTier.cents > 0 ? Math.min(100, (totalCents * 100) / lastTier.cents) : 0;
      if (fillEl) fillEl.style.width = fillPct + '%';

      var unlocked = 0;
      var nextTier = null;
      tiers.forEach(function (tier) {
        if (totalCents >= tier.cents) {
          unlocked++;
        } else if (!nextTier) {
          nextTier = tier;
        }
      });
      if (countEl) countEl.textContent = unlocked + ' / ' + tiers.length;

      tierEls.forEach(function (el) {
        var cents = parseInt(el.dataset.cents, 10) || 0;
        el.classList.toggle('ma-gift-bar__tier--done', totalCents >= cents);
      });

      if (remainingEl) {
        if (nextTier) {
          remainingEl.hidden = false;
          remainingEl.textContent = 'Encore ' + formatMoney(nextTier.cents - totalCents) + ' pour ' + nextTier.label.toLowerCase();
        } else {
          remainingEl.hidden = true;
        }
      }
    }

    checkboxes.forEach(function (cb) { cb.addEventListener('change', render); });
    if (qtyInput) qtyInput.addEventListener('change', render);
    if (bundlePicker) bundlePicker.addEventListener('change', render);
    document.addEventListener('variant:changed', function (event) {
      if (event.detail && event.detail.variant && typeof event.detail.variant.price === 'number') {
        baseCents = event.detail.variant.price;
      }
      render();
    });

    if (window.FoxTheme && window.FoxTheme.pubsub) {
      window.FoxTheme.pubsub.subscribe(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.cart && typeof event.cart.total_price === 'number') {
          baseCartCents = event.cart.total_price;
          render();
        }
      });
    }
    document.addEventListener('cart:updated', function (event) {
      var cart = event.detail && (event.detail.cart || event.detail);
      if (cart && typeof cart.total_price === 'number') {
        baseCartCents = cart.total_price;
        render();
      }
    });

    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
